import { InvoiceType } from '../Types/invoicesTypes';

/**
 * Payment label prefix of a fully paid invoice. It mirrors the backend rule that lets a correction
 * inherit the paid state of its base invoice, including variants such as "Opłacona (zaliczki)".
 */
const PAID_PAYMENT_STATUS_PREFIX = 'Opłacona';

/** Fields of an invoice needed to decide whether a correction is settled on its base invoice. */
export interface CorrectionPaymentSettlementSource {
  type: string;
  correctionInvoiceId?: number | null;
  paymentStatus?: string | null;
  paidAmount?: number | null;
  paidAt?: string | null;
}

/** Payment state a correction reports on behalf of its base invoice. */
export interface CorrectionPaymentSettlement {
  paidAt: string | null;
}

/**
 * An amount-neutral correction of a paid invoice inherits the paid state of the base invoice
 * (payment status and date) but carries no payments of its own (`paidAmount` is exactly 0), so the
 * payment is booked once, on the base invoice. Returns the settlement in that case, otherwise null.
 */
export const resolveCorrectionPaymentSettlement = (
  invoice: CorrectionPaymentSettlementSource
): CorrectionPaymentSettlement | null => {
  if (invoice.type !== InvoiceType.Correction || !invoice.correctionInvoiceId) {
    return null;
  }

  const isPaid = invoice.paymentStatus?.startsWith(PAID_PAYMENT_STATUS_PREFIX) === true;
  if (!isPaid || (invoice.paidAmount ?? 0) !== 0) {
    return null;
  }

  return { paidAt: invoice.paidAt ?? null };
};
